import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { NotificationItem } from "../interfaces/DTO/notification";
import { notificationService } from "../services/notificationService";

export const useBellItems = (enabled: boolean) => {
  return useQuery<NotificationItem[]>({
    queryKey: ["bell-items"],
    queryFn: () => notificationService.getBellItems(),
    staleTime: 60 * 1000,
    refetchInterval: 60 * 1000,
    enabled,
  });
};

export const useMarkSeen = () => {
  const queryClient = useQueryClient();
  return useMutation<void, Error, number>({
    mutationFn: (id) => notificationService.markSeen(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["bell-count"] });
      queryClient.invalidateQueries({ queryKey: ["bell-items"] });
    },
  });
};
